import { TenantSubscription } from '../entities/tenant/tenant';

export enum SecurityModuleDomain {
    Global = 'Global',
    Web = 'Web',
    Mobile = 'Mobile',
    Portals = 'Portals'
}




export enum SecurityModuleName {
    Application = 'Application',
    Configuration = 'Configuration',
    Finance = 'Finance',
    IndividualCompliance = 'Individual Compliance',
    WorkCompliance = 'Work Compliance',
    Jobs = 'Jobs',
    Quotes = 'Quotes',
    Timesheets = 'Timesheets',
    TimeSegments = 'Time Segments',
    Users = 'Users',
    Scheduler = 'Scheduler',
    Contacts = 'Contacts',
    Crm = 'CRM',
    PurchaseOrders = 'Purchase Orders',
    Appointments = 'Appointments',
    Runsheets = 'Runsheets',
    Claims = 'Claims',
    MobileTechnicians = 'Technician Field App',
    PortalContractors = 'Contractor Portal',
    PortalClients = 'Client Portal',
    Reports = 'Reports',
    Variations = 'Variations',
    Assets = 'Assets',
    Defects = 'Defects',
    RecurringJobs = 'Recurring Jobs',
    JobTemplates = 'Job Templates',
    QuoteTemplates = 'Quote Templates',
    Tasks = 'Tasks',
    Sales = 'Sales',
    Dashboards = 'Dashboards',
    Catalogue = "Catalogue",
    Forms = 'Forms',
    Shared = 'Shared',
    AddressValidation = "Address Validation",
    EnterpriseSearch = "Enterprise Search",
    PropertyManagement = "Property Management",
    WorkBuddyConnect = 'WorkBuddy Connect',
    CommandCenter = 'Command Center',
    Equipment = 'Equipment & Hire Billing',
    Tenant = 'Tenant',
    Locations = 'Locations',
    Work = 'Work',
    InboundEmail = 'Inbound Email',
    InboundEmailConfiguration = 'Inbound Email Configuration',
    AIAgent = 'AI Agent',
    Integrations = 'Integrations',
    ProjectJobs = 'Project Jobs',
    MultiStageJobs = 'Multi-Stage Jobs',
}

export interface SecurityModule<T> {
    _id: string;
    name: string;
    domain: SecurityModuleDomain;
    rights: SecurityRight<T>[];
    plan?: TenantSubscription;
    rules?: RightRule[];
    tag?: SecurityModuleTag;
}


export interface SecurityRight<T> {
    _id: T;
    name: string;
    basic: boolean;
    subscription?: TenantSubscription;
    module?: SecurityModuleName;
}

export interface RightRule {
    _id: number;
    value: boolean;
    action: RightRuleAction;
    target: number[];
}

export enum RightRuleAction {
    Enable = 'Enable',
    Disable = 'Disable',
}

export enum SecurityModuleTag {
    Experimental = 'Experimental',
    Deprecated = 'Deprecated',
    Beta = 'Beta',
    Preview = 'Preview',
    Test = 'Test',
}
